/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {MaterialDetailModel} from '../contracts/material-detail.model';
import {SpecialOrderMaterialStatusBaseModel} from '../contracts/special-order-material-status-base.model';
import {Cacheable} from '../../../decorators/cacheable.decorator';

@Injectable({
    providedIn: 'root'
})
export class MaterialService {

    // API endpoints
    materialStatusBaseUrl = `${environment.specialOrdersBaseUrl}/api/material/status/base`;
    materialDetailAllUrl = `${environment.specialOrdersBaseUrl}/api/material/detail?`;

    constructor(protected http: HttpClient) {
    }

    @Cacheable()
    getAllMaterialStatus(): Observable<SpecialOrderMaterialStatusBaseModel[]> {
        return this.http.get<SpecialOrderMaterialStatusBaseModel[]>(this.materialStatusBaseUrl);
    }

    getAutocompleteMaterialsList(query: string, supplyingPackingPlantCode: string, firstResult: number,
                                 maxResults: number): Observable<MaterialDetailModel[]> {
        return this.http.get<MaterialDetailModel[]>(this.materialDetailAllUrl + [
            `numberOrDescription=${query}`,
            `firstResult=${firstResult}`,
            `maxResults=${maxResults}`,
            `supplyingPackingPlantCode=${supplyingPackingPlantCode}`
        ].join('&'));
    }
}
